export default "__VITE_ASSET__0b5adeb1__"